const NO_FILE_NAME = 'no-name';

export const mapIdAndFileToLink = (fileId: string | undefined, fileName: string | undefined) =>
  `/file/${fileId}/content/${encodeURI(fileName || NO_FILE_NAME)}`;
